var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-container",style:(_vm.gridStyle)},_vm._l((_vm.tpl.children),function(item){return _c('div',{key:item.id,staticClass:"grid-cell",style:(_vm.gridCellStyle(item))},[_c('renderer',{attrs:{"tpl":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }